import React, { Component } from "react";
import axios from "axios";
// import HeaderDashboard from "../../part/header.dashaboard";
import FooterDashboard from "../../part/footer.dashboard";
import FilterCourse from "../../part/filter_bar_course";
import Empty from "../../image/empty.svg"
import { Link } from "react-router-dom";
import Policy from "../../part/policy";
import DashSearchHeader from "../../part/header.search.dashboard";
import TutorDashMenu from "../../part/tutor_dash_menu";
import { MdArrowDropDown } from "react-icons/md";
// import ProfileImg from "../../image/icons.png"
import { PiCurrencyNgn } from "react-icons/pi";
import ModifyStudent from "../../part/modifyStudent";




class TutorLibrary extends Component {
    state = {
        menuCoverWidth: this.getInitialMenuCoverWidth(),
        windowHeight: window.innerHeight - 60,
        isActive: false,
        courses: [],
        filter_type_name: "Type",
        filter_level_name: "Level",
        filter_status_name: "Status",
        currentlist: "Interested Cilent",
        saved_course: [],
        interestedStudent: [],
        AppliedUser: [],
        menuwidth: window.innerWidth >= 700,
        columns: {
            sn: true,
            firstName: true,
            lastName: true,
            phoneNo: true,
            middleName: true,
            email: true,
            address: true,
            city: true,
            country: true,
            venue: true,
            specialisation: true,
            source: true,
            courseTitle: true,
            price: true,
            date: true,
            delete: true,
            download: true,
        },
        isContactVisible: false,


        ModStudentID: null,
        activeModifier : false,

    }

    getInitialMenuCoverWidth() {
        const windowWidth = window.innerWidth;
        if (windowWidth < 900) {
            return 0;
        } else if (windowWidth >= 900 && windowWidth < 1200) {
            return 60;
        } else {
            return 260;
        }
    }



    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.fetchCourses();
        this.fetchSaveCourses();
        this.fetchInterestedStudent();
        this.fetchAppliedUser();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/courses/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ courses: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/"; 
              } else {
                console.error("Error fetching data:", error);
              }
        }
    };

    fetchSaveCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/saved-courses/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ saved_course: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/"; 
              } else {
                console.error("Error fetching data:", error);
              }
        }
    };
    fetchInterestedStudent = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/interested-courses/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ interestedStudent: response.data });
            console.log("API Response for interetsed student:", response.data);
        }  catch (error) {
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/"; 
              } else {
                console.error("Error fetching data:", error);
              }
        }
    };
    fetchAppliedUser = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/all-students/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ AppliedUser: response.data });
            console.log("API Response for applied student:", response.data);
        }  catch (error) {
            if (error.response && error.response.status === 401) {
                console.warn("401 Unauthorized error detected. Clearing local storage and redirecting.");
                localStorage.removeItem("accessToken");
                localStorage.removeItem("user");
                window.location.href = "/"; 
              } else {
                console.error("Error fetching data:", error);
              }
        }
    };



    handleResize = () => {
        const menuCover = document.querySelector('.dashboard .menu_cover');
        if (menuCover) {
            this.setState({ menuCoverWidth: menuCover.offsetWidth });
        }
        this.setState({ windowHeight: window.innerHeight - 60 });
        this.setState({ menuwidth: window.innerWidth >= 700 });
    };



    handleRefresh = () => {
        this.setState({
            filter_type_name: "Type",
            selectedItem: "",
            filter_level_name: "Level",
            selectedItems: "",
            filter_status_name: "Status",
            selectedIteme: "",
        }, () => {
            // Important: Call the reset on the child!
            this.filterRef.handleReset(); // Assuming you add a ref to the FilterCourse component
        })
    }

    initialfilterbytype = () => {
        const courses = this.state.courses;
        if (this.state.filter_type_name === "Type" || this.state.filter_type_name === "All") {
            return courses
        } else {
            return courses.filter((item) => item.labels === this.state.filter_type_name);

        }
    };

    initialfilterbylevel = () => {
        const courses = this.initialfilterbytype();

        if (this.state.filter_level_name === "Level" || this.state.filter_level_name === "All") {
            return courses
        } else if (this.state.filter_level_name === "Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Advance" ||
                    item.tags === "Professional"
            );
        } else if (this.state.filter_level_name === "Beginner to Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Beginner to Advance" ||
                    item.tags === "Beginner to Professional"
            );
        }

        else {
            return courses.filter((item) => item.tags === this.state.filter_level_name);

        }
    };
    initialfilterbystatus = () => {
        const courses = this.initialfilterbylevel();
        if (this.state.filter_status_name === "Status" || this.state.filter_status_name === "All") {
            return courses
        } else if (this.state.filter_status_name === "Online") {
            return courses.filter(
                (item) =>
                    item.training_type === "Online Prerecorded" ||
                    item.training_type === "Online Live with Facilitator"
            );
        }
        // If "Physical" is selected, filter for "general physical class" and "private physical class"
        else if (this.state.filter_status_name === "Physical") {
            return courses.filter(
                (item) =>
                    item.training_type === "General Physical Class" ||
                    item.training_type === "Physical Private Class"
            );
        }
        // Default case: If filter_level_name matches a specific training_type directly
        else {
            return courses.filter(
                (item) => item.training_type === this.state.filter_status_name
            );
        }
    };

    handleFilterChange = (filterType, filterLevel, filterStatus) => {
        this.setState({
            filter_type_name: filterType,
            filter_level_name: filterLevel,
            filter_status_name: filterStatus,
        })
    };





    initialfilterbytypeSaved = () => {
        const courses = this.state.saved_course;
        if (this.state.filter_type_name === "Type" || this.state.filter_type_name === "All") {
            return courses
        } else {
            return courses.filter((item) => item.labels === this.state.filter_type_name);

        }

    };

    initialfilterbylevelSaved = () => {
        const courses = this.initialfilterbytypeSaved();
        if (this.state.filter_level_name === "Level" || this.state.filter_level_name === "All") {
            return courses
        } else if (this.state.filter_level_name === "Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Advance" ||
                    item.tags === "Professional"
            );
        } else if (this.state.filter_level_name === "Beginner to Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Beginner to Advance" ||
                    item.tags === "Beginner to Professional"
            );
        }

        else {
            return courses.filter((item) => item.tags === this.state.filter_level_name);

        }
    };
    initialfilterbystatusSaved = () => {
        const courses = this.initialfilterbylevelSaved();
        if (this.state.filter_status_name === "Status" || this.state.filter_status_name === "All") {
            return courses
        } else if (this.state.filter_status_name === "Online") {
            return courses.filter(
                (item) =>
                    item.training_type === "Online Prerecorded" ||
                    item.training_type === "Online Live with Facilitator"
            );
        }
        // If "Physical" is selected, filter for "general physical class" and "private physical class"
        else if (this.state.filter_status_name === "Physical") {
            return courses.filter(
                (item) =>
                    item.training_type === "General Physical Class" ||
                    item.training_type === "Physical Private Class"
            );
        }
        // Default case: If filter_level_name matches a specific training_type directly
        else {
            return courses.filter(
                (item) => item.training_type === this.state.filter_status_name
            );
        }
    };
    enrollfilterData = () => {
        const courses = this.initialfilterbylevel();
        return courses.filter((item) => item.enrolled === true);
    };

    // handledisplayone = (field) => {
    //     const divformone = document.querySelector(".library_content.one")
    //     const divformtwo = document.querySelector(".library_content.two")
    //     // const divformthree = document.querySelector(".library_content.three")
    //     divformone.style.display = "block"
    //     divformtwo.style.display = "none"
    //     // divformthree.style.display = "none"
    //     this.setState({ currentlist: field })
    // }
    // handledisplaytwo = (field) => {
    //     const divformone = document.querySelector(".library_content.one")
    //     const divformtwo = document.querySelector(".library_content.two")
    //     // const divformthree = document.querySelector(".library_content.three")
    //     divformone.style.display = "none"
    //     divformtwo.style.display = "block"
    //     // divformthree.style.display = "none"
    //     this.setState({ currentlist: field })
    // }
    // handledisplaythree = (field) => {
    //     const divformone = document.querySelector(".library_content.one")
    //     const divformtwo = document.querySelector(".library_content.two")
    //     const divformthree = document.querySelector(".library_content.three")
    //     divformone.style.display = "none"
    //     divformtwo.style.display = "none"
    //     divformthree.style.display = "block"
    //     
    // }
    handledisplay = (field) => {
        this.setState({ currentlist: field })
    }
    handleMenuDropDown = () => {
        const profilemenu = document.querySelector("div.library_menu")
        profilemenu.style.display = profilemenu.style.display === "block" ? "none" : "block";
    }
    handleStudentInfoDelete = async (id) => {
        const accessToken = localStorage.getItem("accessToken");

        try {
            await axios.delete(`https://api.geoinfoacademy.com/api/tutor/interested-courses/${id}/`, {

                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },

            });
            // Update the studentList state to remove the deleted item
            this.fetchInterestedStudent()
        } catch (error) {
            console.error('Error deleting interested course:', error);
            // Handle error (e.g., show an error message)
        }
    };


    handleColumnToggle = (columnName) => {
        this.setState((prevState) => ({
            columns: {
                ...prevState.columns,
                [columnName]: !prevState.columns[columnName],
            },
        }));
    };



    IdentifyStudent = (id) =>{
        this.setState({
            ModStudentID : id,
            activeModifier: true,
        })
    }
    RemoveModifier = (id) =>{
        this.setState({
            ModStudentID : null,
            activeModifier: false,
        })
    }




    handleDownloadSingle = async (id) => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get(
                `https://api.geoinfoacademy.com/api/tutor/interested-courses/${id}/download-single/`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    responseType: 'blob', // Important: Indicate that you expect a binary blob
                }
            );

            // Create a blob URL and trigger download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `interested_course_${id}.xlsx`); // Set desired filename
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url); // Clean up the URL object

        } catch (error) {
            console.error("Error downloading single data:", error);
            // Handle error (e.g., show an error message)
        }
    };

    handleDownloadMultiple = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get(
                "https://api.geoinfoacademy.com/api/tutor/interested-courses/download-multiple/",
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                    responseType: 'blob', // Important: Indicate that you expect a binary blob
                }
            );

            // Create a blob URL and trigger download
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'interested_courses_multiple.xlsx'); // Set desired filename
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url); // Clean up the URL object

        } catch (error) {
            console.error("Error downloading multiple data:", error);
            // Handle error (e.g., show an error message)
        }
    };
    render() {
        console.log(this.state.interestedStudent)
        console.log("apply for student", this.state.AppliedUser)
        const { menuwidth } = this.state;
        const { menuCoverWidth, interestedStudent, columns, activeModifier } = this.state;
        const enrolleddata = this.enrollfilterData()
        console.log("ENROLL", enrolleddata, interestedStudent)
        const SavedData = this.initialfilterbystatusSaved()

        // const EnrolledCourses = enrolleddata.length > 0 ? enrolleddata.map((course) => {
        //     return (
        //         <Link to={"/description/" + course.id} >
        //         <section className="course_library" key={course.id}>
        //             <section className="image"><img src={course.thumbnail} alt="course_thumbnail" /></section>
        //             <section className="content">
        //                 <h3>
        //                     <span> {course.labels} : {course.tags}</span><br />
        //                     {course.title}
        //                 </h3>
        //                 <p>{course.training_type} at #{course.price}</p>
        //             </section>
        //         </section>
        //         </Link>
        //     )
        // }) : (
        //     <div className="course_list_empty">
        //         <img src={Empty} alt="not avaialable" /><br />
        //         <h5>No Available Course <br />with that specification.</h5>
        //         <button onClick={this.handleRefresh}>Reset Filter</button>
        //     </div>
        // )


        const SavedCourses = SavedData.length > 0 ? SavedData.map((course) => {
            return (
                <Link to={"/description/" + course.id} >
                    <section className="course_library" key={course.id}>
                        <section className="image"><img src={course.thumbnail} alt="course_thumbnail" /></section>
                        <section className="content">
                            <h3>
                                <span> {course.labels} : {course.tags}</span><br />
                                {course.title}
                            </h3>
                            <p>{course.training_type} at #{course.price}</p>
                        </section>
                    </section>
                </Link>
            )
        }) : (
            <div className="course_list_empty">
                <img src={Empty} alt="not avaialable" /><br />
                <h5>No Available Course <br />with that specification.</h5>
                <button onClick={this.handleRefresh}>Reset Filter</button>
            </div>
        )

        const sortedStudentList = [...interestedStudent].sort((a, b) => b.id - a.id);
        const Studentlist = sortedStudentList.length > 0 ? sortedStudentList.map((info) => {
            return (
                // <section className="library_list" key={info.id}>
                //     <section className="profile">
                //         <div className="image">{info.student.profile_picture !== null ? <img src={info.student.profile_picture} alt={"profile" + info.id} /> : <img src={ProfileImg} alt={"profile" + info.id} />}</div>
                //         <div className="info">
                //             <h4>
                //                 <span>Student</span><br />
                //                 {info.student.first_name}
                //                 {info.student.last_name}
                //             </h4>
                //             <p>{info.student.phone_number}</p>
                //         </div>
                //     </section>
                //     <section className="course">
                //         <h4><span>Course Information</span><br />
                //             {info.course.title}
                //         </h4>
                //         <p>{info.course.price}</p>


                //     </section>
                //     <section className="buttom">
                //         <button onClick={() => this.handleStudentInfoDelete(info.id)}>Remove</button>
                //         <span>{info.interested_date}</span>
                //     </section>
                // </section>
                <tr key={info.id}>
                    {columns.sn && <td className="sn">{info.id}</td>}
                    {columns.firstName && <td>{info.student.first_name}</td>}
                    {columns.lastName && <td>{info.student.last_name}</td>}
                    {columns.middleName && <td>{info.student.middle_name}</td>}
                    {columns.lastName && <td>{info.student.email}</td>}
                    {columns.address && <td>{info.student.address}</td>}
                    {columns.city && <td>{info.student.city}</td>}
                    {columns.country && <td>{info.student.country}</td>}
                    {columns.venue && <td>{info.student.venue}</td>}
                    {columns.specialisation && <td>{info.student.interested_course}</td>}
                    {columns.source && <td>{info.student.source}</td>}
                    {columns.phoneNo && <td>{info.student.phone_number}</td>}
                    {columns.courseTitle && <td className="course">{info.course.title}</td>}
                    {columns.price && <td> <PiCurrencyNgn /> {info.course.price}</td>}
                    {columns.date && <td>{info.interested_date}</td>}
                    {columns.delete && (
                        <td className="delete">
                            <button className="delete-button" onClick={() => this.handleStudentInfoDelete(info.id)} >Delete</button>
                        </td>
                    )}
                    {columns.download && (
                        <td className="delete">
                            <button className="delete-button" onClick={() => this.handleDownloadSingle(info.id)}>Download</button>
                        </td>
                    )}
                </tr>

            )
        }) : (
            <tr className="course_list_empty">
                <td>No interested student</td>
            </tr>
        )








        const AppUserLists = [...this.state.AppliedUser].sort((a, b) => b.id - a.id);
        const Userlist = AppUserLists.length > 0 ? AppUserLists.map((info, index) => {
            return (
                <tr key={info.id}>
                    {columns.sn && <td className="sn">{index  + 1}</td>}
                    {columns.firstName && <td>{info.first_name}</td>}
                    {columns.lastName && <td>{info.last_name}</td>}
                    {columns.middleName && <td>{info.middle_name}</td>}
                    {columns.lastName && <td>{info.email}</td>}
                    {columns.address && <td>{info.address}</td>}
                    {columns.city && <td>{info.city}</td>}
                    {columns.country && <td>{info.country}</td>}
                    {columns.venue && <td>{info.venue}</td>}
                    {columns.specialisation && <td>{info.interested_course}</td>}
                    {columns.source && <td>{info.source}</td>}
                    {columns.phoneNo && <td>{info.phone_number}</td>}
                    <td className="delete"><button className="delete-button" style={{backgroundColor:"green"}} onClick={() => this.IdentifyStudent(info.id)}>Modify</button></td>
                    <Link to={`/studentProfile/${info.id}/${info.first_name}`}><td className="delete"><button className="delete-button" style={{backgroundColor:"green"}} >View</button></td></Link>
                </tr>
 
            )
        }) : (
            <tr className="course_list_empty">
                <td>Loading ......</td>
            </tr>
        )


        return (
            <div className="dashboard">
                <DashSearchHeader onResize={this.handleResize} />
                <TutorDashMenu />
                <div className="dash_body" style={{ width: `calc(100% - ${menuCoverWidth}px - 8px)`, overflow: 'hidden' }} >
                    <div className="course_head " >
                        <h2> My Library </h2>
                        <FilterCourse
                            filterType={this.state.filter_type_name} // Pass current values as props
                            filterLevel={this.state.filter_level_name}
                            filterStatus={this.state.filter_status_name}
                            onFilterChange={this.handleFilterChange}
                            ref={(el) => this.filterRef = el}
                        />
                    </div>
                    <button className="librarymenu" onClick={this.handleMenuDropDown}>{this.state.currentlist} <MdArrowDropDown /></button>
                    <div className="library_menu" style={{ display: menuwidth ? "block" : "none" }}>
                        {/* <li className={this.state.currentlist === "Enrolled" ? "active" : "none"} onClick={() => { this.handledisplayone("Enrolled") }}>Enrolled</li> */}
                        <li className={this.state.currentlist === "Interested Cilent" ? "active" : "none"} onClick={() => { this.handledisplay("Interested Cilent") }} >Interested Cilent</li>
                        <li className={this.state.currentlist === "Saved" ? "active" : "none"} onClick={() => { this.handledisplay("Saved") }} >Saved</li>
                        <li className={this.state.currentlist === "Student" ? "active" : "none"} onClick={() => { this.handledisplay("Student") }} >Student</li>

                        {/* <li>Saved</li> */}
                    </div>
                    {/* <div className="library_content one" >
                        {EnrolledCourses}
                        </div> */}


                    {this.state.currentlist === "Saved" ? 
                    <div className="library_content" >
                        {SavedCourses}
                    </div> : null
                    }



                    {this.state.currentlist === "Interested Cilent" ?
                    <div className="library_content" >
                        <section className="head">
                            <h3>Applied Course<button onClick={this.handleDownloadMultiple}>Download All Applicant</button></h3>
                            <section className="check">
                                <label>
                                    <input type="checkbox" checked={columns.sn} onChange={() => this.handleColumnToggle('sn')} />
                                    S/N
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.firstName} onChange={() => this.handleColumnToggle('firstName')} />
                                    First Name
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.lastName} onChange={() => this.handleColumnToggle('lastName')} />
                                    Last Name
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.middleName} onChange={() => this.handleColumnToggle('middleName')} />
                                    Middle Name
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.email} onChange={() => this.handleColumnToggle('email')} />
                                    Email
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.address} onChange={() => this.handleColumnToggle('address')} />
                                    Address
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.city} onChange={() => this.handleColumnToggle('city')} />
                                    City
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.country} onChange={() => this.handleColumnToggle('country')} />
                                    Country
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.venue} onChange={() => this.handleColumnToggle('venue')} />
                                    Training Venue
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.specialisation} onChange={() => this.handleColumnToggle('specialisation')} />
                                    Area of specialisation
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.source} onChange={() => this.handleColumnToggle('source')} />
                                    Advert source
                                </label>
                                
                                <label>
                                    <input
                                        type="checkbox" checked={columns.phoneNo} onChange={() => this.handleColumnToggle('phoneNo')}
                                    />
                                    Phone No
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.courseTitle} onChange={() => this.handleColumnToggle('courseTitle')}
                                    />
                                    Course Title
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.price} onChange={() => this.handleColumnToggle('price')}
                                    />
                                    Price
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.date} onChange={() => this.handleColumnToggle('date')} />
                                    Date
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.delete} onChange={() => this.handleColumnToggle('delete')} />
                                    Delete
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.download} onChange={() => this.handleColumnToggle('download')} />
                                    Download
                                </label>
                            </section>
                        </section>

                        <div className="table">
                            <table className="librarytable">
                                <thead>
                                    <tr>
                                        {columns.sn && <th className="sn">S/N</th>}
                                        {columns.firstName && <th>First Name</th>}
                                        {columns.lastName && <th>Last Name</th>}
                                        {columns.middleName && <th>Middle Name</th>}
                                        {columns.email && <th>Email</th>}
                                        {columns.address && <th>Address</th>}
                                        {columns.city && <th>City</th>}
                                        {columns.country && <th>Country</th>}
                                        {columns.venue && <th>Training Venue</th>}
                                        {columns.specialisation && <th>Area of specialisation</th>}
                                        {columns.source && <th>Advert source</th>}
                                        {columns.phoneNo && <th>Phone No</th>}
                                        {columns.courseTitle && <th className="course">Course Title</th>}
                                        {columns.price && <th>Price</th>}
                                        {columns.date && <th>Date</th>}
                                        {columns.delete && <th className="delete">Modify</th>}
                                        {columns.download && <th className="delete">Download</th>}

                                    </tr>
                                </thead>
                                <tbody>
                                    {Studentlist}
                                </tbody>
                            </table>
                        </div>

                    </div> : null
                    }


                    {this.state.currentlist === "Student" ?
                    <div className="library_content" >
                        <section className="head">
                            <h3> Student 
                            {/* <button onClick={this.handleDownloadMultiple}>Download All Applicant</button> */}
                            </h3>
                            {/* <section className="check">
                                <label>
                                    <input type="checkbox" checked={columns.sn} onChange={() => this.handleColumnToggle('sn')} />
                                    S/N
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.firstName} onChange={() => this.handleColumnToggle('firstName')} />
                                    First Name
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.lastName} onChange={() => this.handleColumnToggle('lastName')} />
                                    Last Name
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.middleName} onChange={() => this.handleColumnToggle('middleName')} />
                                    Middle Name
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.email} onChange={() => this.handleColumnToggle('email')} />
                                    Email
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.address} onChange={() => this.handleColumnToggle('address')} />
                                    Address
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.city} onChange={() => this.handleColumnToggle('city')} />
                                    City
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.country} onChange={() => this.handleColumnToggle('country')} />
                                    Country
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.venue} onChange={() => this.handleColumnToggle('venue')} />
                                    Training Venue
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.specialisation} onChange={() => this.handleColumnToggle('specialisation')} />
                                    Area of specialisation
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.source} onChange={() => this.handleColumnToggle('source')} />
                                    Advert source
                                </label>
                                
                                <label>
                                    <input
                                        type="checkbox" checked={columns.phoneNo} onChange={() => this.handleColumnToggle('phoneNo')}
                                    />
                                    Phone No
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.courseTitle} onChange={() => this.handleColumnToggle('courseTitle')}
                                    />
                                    Course Title
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.price} onChange={() => this.handleColumnToggle('price')}
                                    />
                                    Price
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.date} onChange={() => this.handleColumnToggle('date')} />
                                    Date
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.delete} onChange={() => this.handleColumnToggle('delete')} />
                                    Delete
                                </label>
                                <label>
                                    <input
                                        type="checkbox" checked={columns.download} onChange={() => this.handleColumnToggle('download')} />
                                    Download
                                </label>
                            </section> */}
                        </section>

                        <div className="table" style={{height:"785px"}}>
                            <table className="librarytable" >
                                <thead>
                                    <tr>
                                        {columns.sn && <th className="sn">S/N</th>}
                                        {columns.firstName && <th>First Name</th>}
                                        {columns.lastName && <th>Last Name</th>}
                                        {columns.middleName && <th>Middle Name</th>}
                                        {columns.email && <th>Email</th>}
                                        {columns.address && <th>Address</th>}
                                        {columns.city && <th>City</th>}
                                        {columns.country && <th>Country</th>}
                                        {columns.venue && <th>Training Venue</th>}
                                        {columns.specialisation && <th>Area of specialisation</th>}
                                        {columns.source && <th>Advert source</th>}
                                        {columns.phoneNo && <th>Phone No</th>}
                                        <th>Modify</th>
                                        <th>View</th>
                                    </tr>
                                </thead>
                                <tbody>
                                  { Userlist}
                                </tbody>
                            </table>
                        </div>

                    </div> : null
                    }


                    {activeModifier ? <ModifyStudent studentId={this.state.ModStudentID} closeform={this.RemoveModifier}/> : null }
                    <FooterDashboard />
                    <Policy />
                </div>
            </div>
        )
    }
}


export default TutorLibrary